import { casingUtil } from '@/utils'
import { EllisIslandAuth, EllisIslandAuthServer } from './types'

export const resolveEllisIslandAuthDown = ({
  ...rest
}: EllisIslandAuthServer) =>
  ({
    ...(casingUtil.snakeToCamel(rest) as EllisIslandAuth),
  } as EllisIslandAuth)
